import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { Core } from "@faire/design-tokens";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import { trackHelpCenterBreadcrumbClick } from "@faire/web-api/events/helpCenter/click/breadcrumb";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography, TypographyStyles } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var HeaderBreadcrumbs = function HeaderBreadcrumbs(_ref) {
  var breadcrumbPaths = _ref.breadcrumbPaths;
  var handleBreadcrumbClick = function handleBreadcrumbClick(pathName) {
    var _getRetailerToken, _getBrandToken;
    trackHelpCenterBreadcrumbClick(pathName, (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "");
  };
  if (getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment()) {
    return /*#__PURE__*/React.createElement(BreadcrumbWrapper, null, breadcrumbPaths.map(function (path, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: path.name
      }, index ? /*#__PURE__*/React.createElement(Slash, null) : null, /*#__PURE__*/React.createElement(BreadcrumbLink, {
        as: Link,
        to: path.to,
        onClick: function onClick() {
          return handleBreadcrumbClick(path.name);
        }
      }, /*#__PURE__*/React.createElement(Typography, null, path.name)));
    }));
  }
  return /*#__PURE__*/React.createElement(Breadcrumb, null, breadcrumbPaths.map(function (path, index) {
    var isLast = index === breadcrumbPaths.length - 1;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: path.name
    }, index ? /*#__PURE__*/React.createElement(Slash, null) : null, isLast ? ( /*#__PURE__*/React.createElement(BreadcrumbText, {
      color: Core.text.subdued,
      onClick: function onClick() {
        return handleBreadcrumbClick(path.name);
      }
    }, path.name)) : ( /*#__PURE__*/React.createElement(BreadcrumbLink, {
      as: Link,
      to: path.to,
      onClick: function onClick() {
        return handleBreadcrumbClick(path.name);
      }
    }, /*#__PURE__*/React.createElement(Typography, null, path.name))));
  }));
};
var BreadcrumbWrapper = styled.div.withConfig({
  displayName: "HeaderBreadcrumbs__BreadcrumbWrapper"
})(["display:flex;overflow:hidden;max-width:100%;flex:1;"]);
var Breadcrumb = styled.div.withConfig({
  displayName: "HeaderBreadcrumbs__Breadcrumb"
})(["display:flex;overflow:hidden;max-width:100%;flex:1;"]);
var BreadcrumbLink = styled.div.withConfig({
  displayName: "HeaderBreadcrumbs__BreadcrumbLink"
})(["position:relative;white-space:nowrap;&:hover:after{content:\"\";display:block;box-sizing:border-box;position:absolute;left:0;bottom:0;width:100%;height:1px;background-color:", ";}"], Core.surface.hover);
var BreadcrumbText = styled(Typography).attrs({
  truncate: true
}).withConfig({
  displayName: "HeaderBreadcrumbs__BreadcrumbText"
})(["position:relative;flex:1;max-width:100%;"]);
var Slash = styled.span.withConfig({
  displayName: "HeaderBreadcrumbs__Slash"
})(["&:before{", " display:inline-block;padding:", ";content:\"/\";vertical-align:top;}"], TypographyStyles({
  color: Core.text.subdued
}), getSpacing(0, "1x"));